import type { Components, Theme } from "@mui/material/styles";
import { tabClasses } from "@mui/material/Tab";

export const MuiTabs: Components<Theme>["MuiTabs"] = {
  styleOverrides: {
    root: {
      overflow: "visible",
      containerType: "scroll-state",
      "@container scroll-state(stuck: top)": {
        "::before": {
          content: '""',
          position: "absolute",
          zIndex: 10,
          top: "calc(100% + 1px)", // 1px is the border-bottom of the tab list
          left: 0,
          right: 0,
          height: "5em", // mask size
          background:
            "linear-gradient(to bottom, var(--mui-palette-background-default), transparent)",
        },
        "> *": {
          // boxShadow:
          //   "0 var(--scroll-shadow-size) var(--scroll-shadow-size) calc(var(--scroll-shadow-size) * -1) var(--scroll-shadow-color, #00000055)",
        },
      },
      [`& .${tabClasses.root}:not(.${tabClasses.selected})`]: {
        color: "var(--mui-palette-text-primary)",
        "&:hover": {
          color: "var(--mui-palette-text-secondary)",
        },
      },
    } as any,
  },
};
